import { z } from 'zod';
import {
  auditFieldsShape,
  localDateTimeSchema,
  utcTimestampSchema,
  uuidSchema,
} from './primitives';

export const NOTIFICATION_SOURCES = [
  'supervisor_reminder',
  'follow_up',
  'calendar_reminder',
  'task_due',
] as const;
export const notificationSourceSchema = z.enum(NOTIFICATION_SOURCES);

export const NOTIFICATION_STATES = ['pending', 'snoozed', 'handled', 'muted'] as const;
export const notificationStateSchema = z.enum(NOTIFICATION_STATES);

export const notificationSchema = z.object({
  id: uuidSchema,
  sourceType: notificationSourceSchema,
  sourceId: uuidSchema,
  /** 冗餘保存，供直接跳轉與查詢。 */
  taskId: uuidSchema.nullable(),
  eventId: uuidSchema.nullable(),
  dueAtLocal: localDateTimeSchema,
  state: notificationStateSchema,
  snoozedUntilLocal: localDateTimeSchema.nullable(),
  handledAt: utcTimestampSchema.nullable(),
  ...auditFieldsShape,
});

export type NotificationSource = z.infer<typeof notificationSourceSchema>;
export type NotificationState = z.infer<typeof notificationStateSchema>;
export type AppNotification = z.infer<typeof notificationSchema>;
